import React from "react";
import { __ } from "@wordpress/i18n";
import { ReviewIcon } from "../../icons";

const ReviewItem = ({ link, logo: Logo, ratings, reviews, ...delegated }) => {
  return (
    <div className="review" {...delegated}>
      <div className="review__image">
        <ReviewIcon />
      </div>
      <div className="review__rating">
        {Logo && (
          <a className="review__reviews" href={link} target="_blank">
          <span className="review__logo">
            <Logo />
          </span>
          </a>
        )}
        {ratings && <div className="review__ratings"><a className="review__reviews" href={link} target="_blank">{ratings} ({reviews} Reviews)</a></div>}
      </div>
      <div className="review__image review__image--flip">
        <ReviewIcon />
      </div>

    </div>
  );
};

export { ReviewItem };
